import _ from 'lodash';
import CustomerAddresses from 'src/entities/customer/CustomerAddresses';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/* Customer Addresses */
export const getCustomerAddresses = (state: any): SingleEntityState<CustomerAddresses> => {
    const data = state.customerAddresses;
    if (_.isEmpty(data)) return singleEntityDefaultState<CustomerAddresses>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new CustomerAddresses(data.content) : undefined,
    };
};
